import { Injectable, afterNextRender } from '@angular/core';

export const DEFAULT_MEDIA_QUERY = 'mq6' as const;

@Injectable({
  providedIn: 'root',
})
export class MediaQueryService {
  private mediaQueryService?: InstanceType<typeof import('@workbench/core').MediaQueryService>;

  constructor() {
    afterNextRender(async () => {
      const { MediaQueryService: WBMediaQueryService } = await import('@workbench/core');
      this.mediaQueryService = new WBMediaQueryService(window);
    });
  }

  public getCurrentMediaQuery() {
    return this.mediaQueryService?.getCurrentMediaQuery() ?? DEFAULT_MEDIA_QUERY;
  }
}
